// --> React
import React from 'react';

// --> Project Imports
import { EstimateFormSection } from 'components';

export default function EstimateRequestPage() {
	return <EstimateFormSection />;
}
